export const GET_USER_DEFINITIONS = "GET_USER_DEFINITIONS"
export const GET_USER_DEFINITIONS_SUCCESS = "GET_USER_DEFINITIONS_SUCCESS"
export const GET_USER_DEFINITIONS_FAIL = "GET_USER_DEFINITIONS_FAIL"

export const GET_USER_DEFINITIONS_BY_USERNAME = "GET_USER_DEFINITIONS_BY_USERNAME"
export const GET_USER_DEFINITIONS_BY_USERNAME_SUCCESS = "GET_USER_DEFINITIONS_BY_USERNAME_SUCCESS"
export const GET_USER_DEFINITIONS_BY_USERNAME_FAIL = "GET_USER_DEFINITIONS_BY_USERNAME_FAIL"

export const ADD_NEW_USER_DEFINITION = "ADD_NEW_USER_DEFINITION"
export const ADD_USER_DEFINITION_SUCCESS = "ADD_USER_DEFINITION_SUCCESS"
export const ADD_USER_DEFINITION_FAIL = "ADD_USER_DEFINITION_FAIL"

export const UPDATE_USER_DEFINITION = "UPDATE_USER_DEFINITION"
export const UPDATE_USER_DEFINITION_SUCCESS = "UPDATE_USER_DEFINITION_SUCCESS"
export const UPDATE_USER_DEFINITION_FAIL = "UPDATE_USER_DEFINITION_FAIL"

export const DELETE_USER_DEFINITION = "DELETE_USER_DEFINITION"
export const DELETE_USER_DEFINITION_SUCCESS = "DELETE_USER_DEFINITION_SUCCESS"
export const DELETE_USER_DEFINITION_FAIL = "DELETE_USER_DEFINITION_FAIL"

export const CREATE_NEW_USER_DEFINITION = "CREATE_NEW_USER_DEFINITION"
export const CREATE_NEW_USER_DEFINITION_SUCCESS = "CREATE_NEW_USER_DEFINITION_SUCCESS"
export const CREATE_NEW_USER_DEFINITION_FAIL = "CREATE_NEW_USER_DEFINITION_FAIL"

export const CONFIRM_NEW_USER_DEFINITION = "CONFIRM_NEW_USER_DEFINITION"
export const CONFIRM_NEW_USER_DEFINITION_SUCCESS = "CONFIRM_NEW_USER_DEFINITION_SUCCESS"
export const CONFIRM_NEW_USER_DEFINITION_FAIL = "CONFIRM_NEW_USER_DEFINITION_FAIL"

export const INSERT_USER_KEYS = "INSERT_USER_KEYS"
export const INSERT_USER_KEYS_SUCCESS = "INSERT_USER_KEYS_SUCCESS"
export const INSERT_USER_KEYS_FAIL = "INSERT_USER_KEYS_FAIL"

export const GET_USER_BY_USERNAME="GET_USER_BY_USERNAME"
export const GET_USER_BY_USERNAME_SUCCESS = "GET_USER_BY_USERNAME"
export const GET_USER_BY_USERNAME_FAIL="GET_USER_BY_USERNAME_FAIL"

export const GET_USER_BY_USERNAME_SYNC="GET_USER_BY_USERNAME_SYNC"
export const GET_USER_BY_USERNAME_SYNC_SUCCESS = "GET_USER_BY_USERNAME_SYNC_SUCCESS"
export const GET_USER_BY_USERNAME_SYNC_FAIL="GET_USER_BY_USERNAME_SYNC_FAIL"

export const GET_USERENCKEY_BY_MERCHANTGUID = "GET_USERENCKEY_BY_MERCHANTGUID"
export const GET_USERENCKEY_BY_MERCHANTGUID_SUCCESS = "GET_USERENCKEY_BY_MERCHANTGUID_SUCCESS"
export const GET_USERENCKEY_BY_MERCHANTGUID_FAIL = "GET_USERENCKEY_BY_MERCHANTGUID_FAIL"
 
export const GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID = "GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID"
export const GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_SUCCESS = "GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_SUCCESS"
export const GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_GUID_FAIL = "GET_USER_ENCRYPTION_KEY_BY_MERCHANT_GUID_GUID_FAIL"
 
export const GET_APIKEY_BY_MERCHANTID = "GET_APIKEY_BY_MERCHANTID"
export const GET_APIKEY_BY_MERCHANTID_SUCCESS = "GET_APIKEY_BY_MERCHANTID_SUCCESS"
export const GET_APIKEY_BY_MERCHANTID_FAIL = "GET_APIKEY_BY_MERCHANTID_FAIL"

export const USER_DEFINITION_API_ERROR = "USER_DEFINITION_API_ERROR"
